<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div v-if="currentUserData.role == 'superAdmin'" class="col-12 q-px-sm">
        <assignApplication
          :id="formData.applications_id"
          @changed="val => (formData.applications_id = val)"
        />
      </div>
      <div class="col-12 q-px-sm">
        <q-input hint v-model="formData.type" label="Name"></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input v-model="deviceColor" label="Device Color" @input="onColorChange">
          <template v-slot:prepend>
            <div class="color-display q-mr-sm" :style="{ backgroundColor: formData.color }"></div>
          </template>
          <template v-slot:append>
            <q-icon name="mdi-palette" class="cursor-pointer">
              <q-popup-proxy ref="colorPopup" cover transition-show="scale" transition-hide="scale">
                <q-color 
                  v-model="formData.color" 
                  default-view="palette" 
                  no-header 
                  class="my-picker"
                  @input="onColorChange" 
                />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-select
          v-model="formData.companyDeviceType"
          label="Type"
          :options="['Flexi-comms', 'Critterpic']"
        ></q-select>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-select
          v-model="formData.deviceSet"
          label="Type Set"
          :options="sets[formData.companyDeviceType]"
        ></q-select>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input
          hint
          v-model="formData.batteryThreshold"
          label="Battery Threshold (Number e.g. 1 or 2.4)"
          type="number"
        ></q-input>
      </div>
      <div class="col-12 col-sm-6 q-px-sm">
        <q-input
          hint
          v-model="formData.heartBeatThreshold"
          label="Heart Beat Threshold (Number)"
          type="number"
          suffix="minutes"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-select
          v-model="formData.imageRotation"
          label="Image Rotation"
          emit-value
          map-options
          :options="[
            {
              label: '0 - No Rotation',
              value: 0
            },
            {
              label: '90 - Rotate 90 degrees',
              value: 90
            },
            {
              label: '180 - Rotate 180 degrees',
              value: 180
            },
            {
              label: '270 - Rotate 270 degrees',
              value: 270
            }
          ]"
        ></q-select>
      </div>
    </div>
    <div v-if="formData.id" class="row items-center q-pt-md">
      <div class="col-12">
        <q-btn
          @click="save()"
          :loading="saveLoading"
          color="primary"
          no-caps
          class="float-right"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save
        </q-btn>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignApplication from "@/components/applications/assignApplication.vue";
import datatable from "@/components/datatable/datatable.vue";
import assignDevice from "@/components/devices/assignDevice.vue";
import chainForm from "@/components/devices/chainForm.vue";

export default {
  components: { assignApplication, assignDevice, datatable, chainForm },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteData: "settings/siteData"
    })
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  },
  data: () => ({
    deviceColor: "#1976D2",
    // Extra Data
    formData: {
      color: "#1976D2" // Default to primary Quasar color
    },
    saveLoading: false,

    sets: {
      "Flexi-comms": ["Trap", "Trap (rb)"],
      Critterpic: ["Picture"]
    }
  }),
  beforeCreate() {
    this.$store.dispatch("applications/loadAll");
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        // Set default color if not present in existing data
        if (!this.formData.color) {
          this.formData.color = "#1976D2";
        }
      } else {
        this.formData = {
          color: "#1976D2" // Default to primary Quasar color
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then(result => {
          if (result) {
            if (this.currentUserData.role != "superAdmin") {
              this.formData.applications_id = this.siteData.id;
            }
            this.$store
              .dispatch("deviceTypes/new", this.formData)
              .then(result => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.saveLoading = true;
      setTimeout(() => {
        this.$store.dispatch("deviceTypes/save", this.formData).then(result => {
          this.saveLoading = false;
          if (result.Result == "Success") {
            // this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: result.Response.Message
            });
          }
        });
      });
    },
    onColorChange(color) {
      // Update the color and close the popup
      console.log("Selected color:", color);
      this.$set(this.formData, 'color', color);
      this.deviceColor = color;
      this.$nextTick(() => {
        this.$refs.colorPopup.hide();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-picker {
  max-width: 250px;
}

.color-display {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #ddd;
}
</style>
